var styles = {
  "Heading": "pb-Heading__Heading",
  "Heading--1": "pb-Heading__Heading--1",
  "Heading--2": "pb-Heading__Heading--2",
  "Heading--accentBar": "pb-Heading__Heading--accentBar",
  "Heading--3": "pb-Heading__Heading--3"
};
export default styles;